export default [
  {
    path: '/language',
    name: "language",
    component: () => import('../views/language/start.vue'),
    children: [
      {
        path: 'member',
        name: "lanMember",
        component: () => import('../views/language/simpleForm.vue'),
        meta: {
          title: '领话费卷'
        }
      },
      {
        path: 'blue',
        name: "lanBlue",
        component: () => import('../views/language/blue.vue'),
        meta: {
          title: '限时开通'
        }
      },
      {
        path: 'red',
        name: "lanRed",
        component: () => import('../views/language/red.vue'),
        meta: {
          title: '会员注册'
        }
      },
      {
        path: 'redConfirmOrder',
        name: "lanRedConfirmOrder",
        component: () => import('../views/language/redConfirmOrder.vue'),
        meta: {
          title: '申请成功'
        }
      },
      {
        path: 'confirmorder',
        name: "lanConfirmOrder",
        component: () => import('../views/language/confirmOrder.vue'),
        meta: {
          title: '确认订单'
        }
      },
      {
        path: 'wxconfirmorder/:mobile/:verifyCode/:oid',
        name: "lanWXConfirmOrder",
        component: () => import('../views/language/wxConfirmOrder.vue'),
        meta: {
          title: '确认订单'
        }
      },
      {
        path: 'simpleform',
        name: "lanSimpleForm",
        component: () => import('../views/language/simpleForm.vue'),
        meta: {
          title: '领话费卷'
        }
      },
      {
        path: 'cqmember',
        name: "lanCQMember",
        component: () => import('../views/language/cqmember.vue'),
        meta: {
          title: '重庆移动用户赚享'
        }
      }
    ]
  }
]